export default __webpack_public_path__ + "static/media/logo-w.0c4a61b3.png";